import pythonApiClient from './pythonBaseApi';

const planillaEmpleadosApi = {
  /** Obtener listado de empleados para planilla */
  getPlanillasPorPeriodo: (anio, mes, search = '', proyectoId = null) => {
    const params = new URLSearchParams({ anio, mes });
    if (search) params.append('search', search);
    if (proyectoId) params.append('proyecto_id', proyectoId);
    return pythonApiClient.get(`/rrhh/planilla-empleados?${params}`);
  },

  /** Crear planilla individual */
  createPlanilla: (data) =>
    pythonApiClient.post('/rrhh/planilla-empleados', data),

  /** Actualizar planilla individual */
  updatePlanilla: (id, data) =>
    pythonApiClient.put(`/rrhh/planilla-empleados/${id}`, data)
};

export default planillaEmpleadosApi;
